// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"2907d782","287":"07fa3eff","332":"09a51799"}[chunkId] + ".chunk.css";
};